import "./EmployeeBankSetupStyle.css";

import * as yup from "yup";

import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedDialog,
	EnhancedSnackbar,
	SingleColumnLayout,
	StandardPanel,
	TwoColumnLayout,
} from "@websential/cosmic-v20";
import { Box, Button, Card, Grid, Typography, useTheme } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import {
	IGetListRequest,
	IResponse,
	IServerError,
} from "../../models/common";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	sortDDLByLabel,
	useNavigateToLogout,
} from "../../common/Common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { BankService } from "../../services/BankService";
import { BasicSetupFormToolbar } from "../BasicSetupFormToolbar";
import { CountryService } from "../../services/common/CountryService";
import { DDLDataTable } from "../DDLDataTable";
import { EmployeeBankSetupFieldsPanel } from "./Panels/EmployeeBankSetupFieldsPanel";
import { EmployeeBankSetupFieldsRightPanel } from "./Panels/EmployeeBankSetupFieldsRightPanel";
import { EmployeeBankSetupToolbar } from "./EmployeeBankSetupToolbar/EmployeeBankSetupToolbar";
import { EmployeeBankSetupValidationSchema } from "./validator";
import { EmployeeService } from "../../services/EmployeeService";
import { EnhancedButtonPrimeReact } from "../EnhancedButtonPrimeReact";
import { IAppState } from "../../store/reducers";
import { IEmployee } from "../../models";
import { IEmployeeBank } from "../../models/Employee/EmployeeBank";
import { VerifyBankDialogue } from "../VerifyBankDialogue";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions/stickyNavBarActions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { IClient } from "../../models/client";



























export interface IEmployeeBankSetup { }
const SINGLE_RECORD_DATA_QUERY_KEY = "employee-single-data-record";
const EMPLOYEE_BANKS_DATA_QUERY_KEY = "employee-bank-list";
const EMPLOYEE_BANKS_DDL_DATA_QUERY_KEY = "employee-bank-ddl";

const useGetDataEmployeeBankByIdById = (
	id: string | undefined,
	clientId: string,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id, clientId],
		queryFn: () => {
			return EmployeeService.getEmployeeBankDataById(id, clientId, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

const useGetEmployeeDDL = (clientId: string) =>
	useQuery({
		queryKey: ["Employee-ddl", clientId],
		queryFn: () => {
			return EmployeeService.getEmployeeBankDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

// const useGetEmployeeBankList = (
// 	clientId: string,
// 	params: IGetListRequest,
// 	navigateToLogout: (path: string) => void
// ) =>
// 	useQuery({
// 		queryKey: [EMPLOYEE_BANKS_DATA_QUERY_KEY],
// 		queryFn: (data) => {

// 			return EmployeeService.getGetEmployeeBankList(
// 				clientId,
// 				params,
// 				navigateToLogout
// 			);
// 		},
// 		refetchOnWindowFocus: false,
// 	});
// const useGetClientBankDDL = (clientId: string | undefined) =>
// 	useQuery({
// 		queryKey: [EMPLOYEE_BANKS_DDL_DATA_QUERY_KEY],
// 		queryFn: () => {
// 			return !clientId ? null : ClientService.getGetClientBankDDL(clientId);
// 		},
// 		refetchOnWindowFocus: false,
// 	});
// const useGetCountryDDL = () =>
// 	useQuery({
// 		queryKey: ["country-ddl"],
// 		queryFn: (data) => {
// 			return CountryService.getCountryDDL();
// 		},
// 		refetchOnWindowFocus: false,
// 	});


export const EmployeeBankSetup: React.FC<IEmployeeBankSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const [employeeIdState, setEmployeeId] = useState(clientId);
	const [openDialog, setDialogOpen] = useState(false);
	const [isPendingData, setIsPendingData] = useState(false);
	const accountantId = useSelector((state: IAppState) => state.accountant.id);
	const [openArchiveDialog, setArchiveDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [singleArchive, setSingleArchive] = useState<boolean>(false);
	const [employeeBanksId, setEmployeeBanksId] = useState<number | string>(0);
	const [itemSearch, setItemSearch] = useState("");
	const [sidePanelsVisibility, setSidePanelsVisibility] = useState(true);
	const [selectedCard, setSelectedCard] = useState<any>(null);
	const [employeeBankId, setEmployeeBankId] = useState<any>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [selectedSplit, setSelectedSplit] = useState(200)
	const [selectedEmployeeWhichHaveNoBank, setSelectedEmployeeWhichHaveNoBank] = useState()
	const queryEmployee = useQueryClient();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const navigateToLogout = useNavigateToLogout();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "departmentName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	// [Verify]
	const [openVerifyBankDialogue, setOpenverifyBankDialogue] = useState(false)
	const [isAccountCheck, setIsAccountCheck] = useState<any>(null);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null ? requestParams.sortField : "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	// useEffect(() => {
	// 	setEditRecordId(id)
	// }, [id])

	// const { isPending, data } = useGetEmployeeBankList(
	// 	employeeIdState,
	// 	queryParams,
	// 	navigateToLogout
	// );

	// const employeeBankList: any | null = data;


	const { isPending: isSubmitting, mutate: submitEmployeeBankFormFields } =
		useMutation({
			mutationFn: EmployeeService.createEmployeeBank,
			onSuccess: (res: IEmployeeBank | IServerError | IResponse | any) => {

				if (res.status === 200) {
					setEditRecordId(res.data.employeeId);
					queryEmployee.invalidateQueries({
						queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
					});
					queryEmployee.invalidateQueries({
						queryKey: [EMPLOYEE_BANKS_DATA_QUERY_KEY],
					});
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/employee/bank-setup/${res.data.employeeId}`;
					navigate(path);
					// (async () => {
					// 	try {
					// 		setIsPendingData(true);
					// 		const clientBanksDDL =
					// 			await ClientService.getGetClientBankDDL(
					// 				res.data.clientId
					// 			);
					// 		if (Array.isArray(clientBanksDDL)) {
					// 			const sortedList = sortData(clientBanksDDL);
					// 			const filteredList =
					// 				sortedList &&
					// 				sortedList.filter((item: any) =>
					// 					item.label.toLowerCase().includes(itemSearch.toLowerCase())
					// 				);
					// 			setemployeeBankList(filteredList);
					// 		}
					// 		let path = `/employee/bank-setup/${res.data.id}`;
					// 		navigate(path);
					// 	} catch {

					// 	} finally {
					// 		setIsPendingData(false);
					// 	}
					// })();
				} else if (res.status === 201) {
					setEditRecordId(res.data.employeeId);
					queryEmployee.invalidateQueries({
						queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
					});
					queryEmployee.invalidateQueries({
						queryKey: [EMPLOYEE_BANKS_DATA_QUERY_KEY],
					});
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// }
					let path = `/employee/bank-setup/${res.data.employeeId}`;
					navigate(path);
					// (async () => {
					// 	try {
					// 		setIsPendingData(true);
					// 		const clientBanksDDL =
					// 			await ClientService.getGetClientBankDDL(
					// 				res.data.clientId
					// 			);
					// 		if (Array.isArray(clientBanksDDL)) {
					// 			const sortedList = sortData(clientBanksDDL);
					// 			const filteredList =
					// 				sortedList &&
					// 				sortedList.filter((item: any) =>
					// 					item.label.toLowerCase().includes(itemSearch.toLowerCase())
					// 				);
					// 			setemployeeBankList(filteredList);
					// 		}
					// 		let path = `/employee/bank-setup/${res.data.id}`;
					// 		navigate(path);
					// 	} catch {

					// 	} finally {
					// 		setIsPendingData(false);
					// 	}
					// })();
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	// const EmployeeBankSetupValidationSchema = yup.object().shape({
	// 	account1Name: yup.string().required("BankName is required")
	// });

	const DEFAULT_VALUES = {
		account1Name: undefined,
		account1No: undefined,
		branchTransitNoAccount1: null,
		bankFinancialNoAccount1: null,
		account2Name: undefined,
		account2No: null,
		branchTransitNoAccount2: null,
		bankFinancialNoAccount2: null,
		split: 200,
		percenagePerDollorInAcc1: null,
	};

	const formMethods = useForm<any>({
		resolver: yupResolver(EmployeeBankSetupValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES,
	});

	const { isLoading: isLoadingBankDeytails, data: selectedDataRecord } = useGetDataEmployeeBankByIdById(
		editRecordId,
		clientId,
		navigateToLogout
	);



	const { data: employeeDDL } = useGetEmployeeDDL(clientId);


	const onSelectionChangeHandler = (e: any) => {
		formMethods.reset();
		setEditRecordId(e.value)
		formMethods.setValue('employeeName', e.label)
	}
	const upadtedEmployeeBankListItems = useMemo(() => {
		return (
			employeeDDL &&
			employeeDDL &&
			sortDDLByLabel(employeeDDL).map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/employee/bank-setup/${item.value}`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						onClick={() => onSelectionChangeHandler(item)}>
						{item.label}
					</Link>
				),
			}))
		);
	}, [employeeDDL]);
	const onEmployeeSelectionChangeHandler = (selected: any) => {
		setEditRecordId(selected.value);
		if (selected.value) navigate(`/employee/bank-setup/${selected.value}`)
		if (!selected.value) formMethods.reset();
		if (!selected.value) formMethods.setValue("percenagePerDollorInAcc1", "percenagePerDollorInAcc1")
	};


	const onEmployeeBankSelectionChangeHandler = async (params: any) => {
		setEmployeeId(params.value);
		// try {
		// 	setIsPendingData(true);
		// 	const clientBanksDDL =
		// 		await ClientService.getGetClientBankDDL(params.value);
		// 	if (Array.isArray(clientBanksDDL)) {
		// 		const sortedList = sortData(clientBanksDDL);
		// 		const filteredList =
		// 			sortedList &&
		// 			sortedList.filter((item: any) =>
		// 				item.label.toLowerCase().includes(itemSearch.toLowerCase())
		// 			);
		// 		setemployeeBankList(filteredList);
		// 	}
		// } catch {

		// } finally {
		// 	let path = `/clients/bank-setup`;
		// 	navigate(path);
		// 	formMethods.setValue('name',"")
		// 	formMethods.setValue('accountNo',"")
		// 	formMethods.setValue('branchTransitNumber',"")
		// 	formMethods.setValue('bankFinancialNo',"")
		// 	formMethods.setValue('primaryAccount',false)
		// 	formMethods.setValue('status',200)
		// 	setSelectedCard(null);
		// 	setIsPendingData(false);
		// }
	};

	// const { data: clientBankLabelsList } = useGetClientBankDDL(clientId);

	// useEffect(() => {

	// 	if (Array.isArray(clientBankLabelsList)) {
	// 		setemployeeBankList(sortData(clientBankLabelsList));
	// 	} else {
	// 		setemployeeBankList(undefined)
	// 	}
	// }, [clientBankLabelsList]);

	// const filteredList =
	// 	employeeBankList &&
	// 	employeeBankList.filter((item: any) =>
	// 		item.label.toLowerCase().includes(itemSearch.toLowerCase())
	// 	);

	// const { isPending: isPendingCountryDDL, data: countryList } =
	// 	useGetCountryDDL();
	// let countryList = [
	// 	{
	// 		shortCode: "CAN",
	// 		value: "6718c0e02bd6872c87d35d0f",
	// 		label: "Canada",
	// 		countryType: "Province",
	// 	},
	// 	{
	// 		logo: "",
	// 		shortCode: "USA",
	// 		value: "67496d974b9fb9f2ce4213b9",
	// 		label: "United States of America",
	// 		countryType: "state",
	// 	},
	// ];

	const [openBranchAddedDialog, setOpenBranchAddedDialog] = useState(false);
	const [pendingValues, setPendingValues] = useState<any>(null);
	const onCloseBranchAddedHandler = () => {
		setOpenBranchAddedDialog(false)
	}
	const onConfirmBranchSubmit = () => {
		if (pendingValues) {
			setOpenBranchAddedDialog(false);
			setPendingValues(null);
			let payload = {
				clientId: clientId,
				employeeId: id && id,
				id: selectedDataRecord && selectedDataRecord.id && selectedDataRecord.id,
				account1Name: pendingValues.account1Name,
				account1No: pendingValues.account1No,
				branchTransitNoAccount1: pendingValues.branchTransitNoAccount1,
				bankFinancialNoAccount1: pendingValues.bankFinancialNoAccount1,
				account2Name: pendingValues.account2Name,
				account2No: pendingValues.account2No,
				branchTransitNoAccount2: pendingValues.branchTransitNoAccount2,
				bankFinancialNoAccount2: pendingValues.bankFinancialNoAccount2,
				split: pendingValues.split,
				percenagePerDollorInAcc1: pendingValues.percenagePerDollorInAcc1,
				navigateToLogout: navigateToLogout,
			};
			submitEmployeeBankFormFields(payload);
		}
	};

	const onSubmit = async (values: any) => {
		if (id) {
			if (values.account1No && values.account1No !== null && values.account1No !== "") {
				try {
					setIsPendingData(true)
					const verifyBank = await BankService.bankOrBranchExists(values.bankFinancialNoAccount1, values.branchTransitNoAccount1);
					console.log("verifyBank", verifyBank)
					if (verifyBank && verifyBank.bankExist && verifyBank.branchExist) {
						let payload = {
							clientId: clientId,
							employeeId: id && id,
							id: selectedDataRecord && selectedDataRecord.id && selectedDataRecord.id,
							account1Name: values.account1Name,
							account1No: values.account1No,
							branchTransitNoAccount1: values.branchTransitNoAccount1,
							bankFinancialNoAccount1: values.bankFinancialNoAccount1,
							account2Name: values.account2Name,
							account2No: values.account2No,
							branchTransitNoAccount2: values.branchTransitNoAccount2,
							bankFinancialNoAccount2: values.bankFinancialNoAccount2,
							split: values.split,
							percenagePerDollorInAcc1: values.percenagePerDollorInAcc1,
							navigateToLogout: navigateToLogout,
						};
						submitEmployeeBankFormFields(payload);
					}
					if (verifyBank && !verifyBank.bankExist) {
						setSnackbarData({
							open: true,
							message: "Bank does not exist",
							severity: "error"
						})
					}
					if (verifyBank && verifyBank.bankExist && !verifyBank.branchExist) {
						setPendingValues(values);
						setOpenBranchAddedDialog(true);
					}

					setIsPendingData(false)
				}
				catch { setIsPendingData(false) }
			} else if (values.account2No && values.account2No !== null && values.account2No !== "") {
				try {
					setIsPendingData(true)
					const verifyBank = await BankService.bankOrBranchExists(values.bankFinancialNoAccount2, values.branchTransitNoAccount2);
					console.log("verifyBank", verifyBank)
					if (verifyBank && verifyBank.bankExist && verifyBank.branchExist) {
						let payload = {
							clientId: clientId,
							employeeId: id && id,
							id: selectedDataRecord && selectedDataRecord.id && selectedDataRecord.id,
							account1Name: values.account1Name,
							account1No: values.account1No,
							branchTransitNoAccount1: values.branchTransitNoAccount1,
							bankFinancialNoAccount1: values.bankFinancialNoAccount1,
							account2Name: values.account2Name,
							account2No: values.account2No,
							branchTransitNoAccount2: values.branchTransitNoAccount2,
							bankFinancialNoAccount2: values.bankFinancialNoAccount2,
							split: values.split,
							percenagePerDollorInAcc1: values.percenagePerDollorInAcc1,
							navigateToLogout: navigateToLogout,
						};
						submitEmployeeBankFormFields(payload);
					}
					if (verifyBank && !verifyBank.bankExist) {
						setSnackbarData({
							open: true,
							message: "Bank does not exist",
							severity: "error"
						})
					}
					if (verifyBank && verifyBank.bankExist && !verifyBank.branchExist) {
						setPendingValues(values);
						setOpenBranchAddedDialog(true);
					}

					setIsPendingData(false)
				}
				catch { setIsPendingData(false) }
			} else {
				let payload = {
					clientId: clientId,
					employeeId: id && id,
					id: selectedDataRecord && selectedDataRecord.id && selectedDataRecord.id,
					account1Name: values.account1Name,
					account1No: values.account1No,
					branchTransitNoAccount1: values.branchTransitNoAccount1,
					bankFinancialNoAccount1: values.bankFinancialNoAccount1,
					account2Name: values.account2Name,
					account2No: values.account2No,
					branchTransitNoAccount2: values.branchTransitNoAccount2,
					bankFinancialNoAccount2: values.bankFinancialNoAccount2,
					split: values.split,
					percenagePerDollorInAcc1: values.percenagePerDollorInAcc1,
					navigateToLogout: navigateToLogout,
				};
				// let finalPayload = {
				// 	payload: payload,
				// }
				// alert(JSON.stringify(payload, null, 2));
				submitEmployeeBankFormFields(payload);
			}
		} else {
			{
				setSnackbarData({
					open: true,
					message: "Please Select Employee.",
					severity: "warning",
				});
			}
		}
	};

	useEffect(() => {
		if (id && selectedDataRecord && selectedDataRecord.id) {
			Object.keys(selectedDataRecord).forEach((fieldName) => {
				const fieldValue = selectedDataRecord[fieldName];
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (fieldName === "percenagePerDollorInAcc1") {
					formMethods.setValue(fieldName, fieldValue ?? undefined);
				}
				if (fieldName === "split") {
					setSelectedSplit(fieldValue)
				}
			});
		} else {
			setSelectedSplit(200)
			formMethods.setValue('account1Name', null)
			formMethods.setValue('account1No', null)
			formMethods.setValue('branchTransitNoAccount1', null)
			formMethods.setValue('bankFinancialNoAccount1', null)
			formMethods.setValue('account2Name', null)
			formMethods.setValue('account2No', null)
			formMethods.setValue('branchTransitNoAccount2', null)
			formMethods.setValue('bankFinancialNoAccount2', null)
			formMethods.setValue('split', 200)
			formMethods.setValue('percenagePerDollorInAcc1', null)
		}
	}, [id && selectedDataRecord]);



	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteEmployeeById } = useMutation({
		mutationFn: EmployeeService.delEmployeeBank,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {

				queryEmployee.invalidateQueries({
					queryKey: [EMPLOYEE_BANKS_DATA_QUERY_KEY],
				});
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				setSelectedSplit(200)
				formMethods.setValue('account1Name', null)
				formMethods.setValue('account1No', null)
				formMethods.setValue('branchTransitNoAccount1', null)
				formMethods.setValue('bankFinancialNoAccount1', null)
				formMethods.setValue('account2Name', null)
				formMethods.setValue('account2No', null)
				formMethods.setValue('branchTransitNoAccount2', null)
				formMethods.setValue('bankFinancialNoAccount2', null)
				formMethods.setValue('split', 200)
				formMethods.setValue('percenagePerDollorInAcc1', null)
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			setEditRecordId(undefined)
			let path = `/employee/bank-setup`;
			navigate(path);
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const deleteEmployeeField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let payload = {
				employeeBankId: employeeBankId,
				clientId: clientId
			}
			deleteEmployeeById(payload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = () => {
		setDialogOpen(true);
		setSingleDelete(true);
		if (id) {
			setEmployeeBankId(id);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {

		setDialogOpen(true);
		setSingleDelete(true);
		setEmployeeBankId(params.id);
	}, []);

	const { isPending: isArchive, mutate: archiveEmployeeBanksById } = useMutation({
		mutationFn: EmployeeService.archiveEmployeeBank,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the ClientBanks fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			formMethods.reset();
			let path = `/employee/bank-setup`;
			navigate(path);
			return queryEmployee.invalidateQueries({
				queryKey: [EMPLOYEE_BANKS_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const archiveEmployeeBanksField = () => {
		if (singleArchive) {
			setSingleArchive(false);
			let ArchivePayload = {
				employeeBanksId: employeeBanksId,
				navigateToLogout: navigateToLogout,
			};
			archiveEmployeeBanksById(ArchivePayload);
			setArchiveDialogOpen(false);
		}
	};

	const onArchiveClicked = () => {
		setArchiveDialogOpen(true);
		setSingleArchive(true);
		if (selectedDataRecord) {
			setEmployeeBanksId(selectedDataRecord.id);
		}
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};
	const onCloseArchiveHandler = () => {
		setArchiveDialogOpen(false);
	};

	const onRowEditClicked = useCallback((params: any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/employee/bank-setup/${params.value}`;
		navigate(path);
	}, []);

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		formMethods.setValue("percenagePerDollorInAcc1", "percenagePerDollorInAcc1")
		let path = `/employee/bank-setup`;
		navigate(path);
	};

	const expandedLabels = ["Employee", "Bank"];
	const expandedHomeBankSetupOrSetupItem = "Bank"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			if (clientId && clientId !== "") {
				let isExpanded = expandedLabels.includes(item.label);
				if (parentLabel === "Employee" && item.label === expandedHomeBankSetupOrSetupItem) {
					isExpanded = true;
				}
				const enhancedItem = {
					...item,
					expanded: item.items ? isExpanded : false,
					items: item.items ? enhanceData(item.items, item.label) : undefined,
					path: item.label === expandedHomeBankSetupOrSetupItem && "/employee/bank-setup",
				};
				return enhancedItem;
			}
		});
	};

	useEffect(() => {

		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);


	console.log("selectedDataRecordselectedDataRecord", selectedDataRecord)
	return (
		<Grid

		>
			<BackdropCircularProgress
				open={isSubmitting || isPendingData || isDeleting || isArchive || isLoadingBankDeytails}
				testId="comapny Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteEmployeeField}
				cancelActionHandler={onCloseHandler}
				testId="employee-confirmation-dialog"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}

					>
						<Grid size={{ xs: 12, sm: 12, md: 8.5, lg: 8, xl: 8 }}
						>
							<TwoColumnLayout

								toolbar={
									<BasicSetupFormToolbar
										onResetClicked={onResetClicked}
										onDeleteClicked={onDeleteClicked}
										isSubmitting={false}
										id={id && selectedDataRecord && selectedDataRecord.id && selectedDataRecord.id}
										pageTitle="Employee Bank"
									/>
								}
								leftColumnContent={
									<>
										<StandardPanel
											title="Account 1"
											testId={`account1-bank-setup`}
											showTitle={true}
											// variant="outlined"
											topPadding={2}
											borderHide={true}

										>
											<EmployeeBankSetupFieldsPanel
												testId={"Employee-Bank-info-panel"}
												isAdminUser={isAdminUser}
												setSelectedSplit={setSelectedSplit}
												formMethods={formMethods}
												// onVerifyBankClickedHandler={() => setOpenverifyBankDialogue(true)}
												onVerifyBankClickedHandler={() => {
													setIsAccountCheck("Account1");
													setOpenverifyBankDialogue(true);
												}}
												employeeDDL={employeeDDL && employeeDDL} onEmployeeSelectionChangeHandler={onEmployeeSelectionChangeHandler}
											/>
										</StandardPanel>


									</>

								}
								rightColumnContent={
									<>

										<StandardPanel
											title="Account 2"
											testId={`account2-bank-setup`}
											showTitle={true}
											// variant="outlined"
											topPadding={2}
											borderHide={true}
										>
											<EmployeeBankSetupFieldsRightPanel
												testId={"Employee-Bank-info-right-panel"}
												isAdminUser={isAdminUser}
												selectedSplit={selectedSplit}
												// onVerifyBankClickedHandler={() => setOpenverifyBankDialogue(true)}
												onVerifyBankClickedHandler={() => {
													setIsAccountCheck("Account2");
													setOpenverifyBankDialogue(true);
												}}
											/>
										</StandardPanel>

									</>
								}
								toolbarPosition="top"
								testId="form-layout"

							/>
						</Grid>
						<Grid size={{ xs: 12, sm: 12, md: 0.2, lg: 1, xl: 1 }}></Grid>
						<Grid
							size={{ xs: 12, sm: 12, md: 3.3, lg: 3, xl: 3 }}
							sx={{ marginTop: "16px", display: { xs: "none", sm: "none", md: "block" } }}
						>
							<DDLDataTable
								rows={
									employeeDDL && upadtedEmployeeBankListItems ? upadtedEmployeeBankListItems : []}
								onRowEditClicked={onRowEditClicked}
								// onRowDeleteClicked={onRowDeleteClicked}
								onRowArchiveClicked={onArchiveClicked}
								// isLoading={isPending}
								// totalRecords={
								// 	employeeBankList && employeeBankList.total
								// 		? employeeBankList.total
								// 		: 0
								// }
								showDeleteIcon={false}
								totalRecords={
									employeeDDL && employeeDDL
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChange}
								tableScrollHeight={"60vh"}
								showPaginator={false}
								selectedId={selectedDataRecord && id && selectedDataRecord.employeeId ? selectedDataRecord && id && selectedDataRecord.employeeId : id}
							/>
						</Grid>
					</Grid>
				</form>
			</FormProvider>

			{/* Archive Dialogue */}
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseArchiveHandler}
				open={openArchiveDialog}
				dialogContent={null}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseArchiveHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Archive"
							severity="secondary"
							raised
							onClickHandler={() => archiveEmployeeBanksField}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>
			<VerifyBankDialogue openVerifyBankDialogue={openVerifyBankDialogue} setOpenVerifyBankDialogue={(value: any) => setOpenverifyBankDialogue(value)} parentFormMethods={formMethods}
				isAccountCheck={isAccountCheck}
			/>
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseBranchAddedHandler}
				open={openBranchAddedDialog}
				dialogContent={
					<Box>
						<Typography variant="body2" sx={{ mb: 2 }}>
							Account 1 Branch / Transit No. is not a valid code as listed in our current banking records. If you believe this is correct, please mail us.
						</Typography>
						<Typography variant="body2">
							Note: Penalty amount will be deducted for providing incorrect bank details.
						</Typography>
					</Box>
				}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseBranchAddedHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Ok"
							severity="success"
							raised
							onClickHandler={onConfirmBranchSubmit}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"employee-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
